import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ContextService } from '../../services/context.service';
import {
  fetchAuthSession,
  signInWithRedirect,
  signOut,
} from 'aws-amplify/auth';
//import { SelectionModel } from '../../../shared/model/selection-model';
//import { PlantEnum } from '../../../shared/model/plant-enum';
import { Store } from '@ngrx/store';
import { userInfo } from '../../../store/model/user.models';
import { Observable } from 'rxjs';
import { WelcomeService } from '../../services/welcome.service';
import { AuthService, UserInformation } from '../../services/auth.service';
import { Chart } from 'chart.js/auto';
import { ThemeService } from '../../services/theme.service';
import { authorizedUsers } from '../../../shared/constants/admin-users.constant';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
  standalone: false,
})
export class TopBarComponent implements OnInit {
  // plantOptions : Array<SelectionModel>;
  // selectedValue : SelectionModel;
  userInformation: UserInformation | undefined = undefined;
  isDarkMode = false;

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;

  //user$: Observable<userInfo | null>;

  constructor(
    public context: ContextService,
    private welcomeService: WelcomeService,
    private store: Store,
    private auth: AuthService,
    private themeService: ThemeService,
  ) {
    //this.plantOptions = Object.keys(PlantEnum).map(key => ({ name: PlantEnum[key as keyof typeof PlantEnum], value: key }));
    //this.selectedValue = this.plantOptions[0];
    //this.user$ = this.store.select(selectUser);
    this.auth.user$.subscribe(
      (userInformation) => (this.userInformation = userInformation),
    );
  }

  ngOnInit(): void {
    this.themeService.darkMode$.subscribe((isDark) => {
      this.isDarkMode = isDark;
    });
  }
  async handleSignOut() {
    try {
      await signOut();
      this.welcomeService.markNotSeen();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  toggleDarkMode() {
    this.themeService.toggleDarkMode();
  }
}
